// components/UserAvatar.js
import { Avatar, Tooltip, Typography } from "@mui/material";
import { get, getFile } from "api/apiBridges/httpBridge";
import { SocketContext } from "components/socketLib/ConnectorSocket";
import useOn from "components/socketLib/UseOn";
import { useContext } from "react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { loginSelector } from "store/slices/loginSlice";

export default function UserAvatar({
  src,
  userData,
  user_id, //нужен, чтобы была возможность актуально обновлять не только свой аватар, но и чужие, например можно пережать id менеджера
  size = 88,
  marginRight = "5px", // значение по умолчанию
  useToolTip = true
}) {

  const [photo, setPhoto] = useState( undefined );
  const [user, setUser] = useState( {
    fio: "",
    email: "",
    mobile_number: ""
  } );

  const getPhoto = async (path) => {
    try {
      let photo = undefined;
      if (path) {
        photo = await getFile("png", { path })
      }
      setPhoto(photo);
    }
    catch (err) {
      console.error("Ошибка при загрузке пользователя", err);
    }
  }

  useOn('setAvatar', async (data) => {
      console.log("setAvatar", data)
      if (data.user_id === user_id ) {
        await getPhoto(data.path)
      }      
  });

  useOn('userSettingsUpdateGet', async (data) => {
      let tmp = JSON.parse(JSON.stringify(user))
      if (data.fio) {tmp.fio = data.fio}
      if (data.email) {tmp.email = data.email}
      if (data.mobile_number) {tmp.mobile_number = data.mobile_number}
      setUser(tmp)
  });
  
  
  useEffect(() => {
    const fetchData = async () => {
      await getPhoto(src)
    };

    fetchData();
  }, [src]);

  useEffect(() => {
    if (userData) setUser(userData)
  }, [userData]);

  // Получаем инициалы из ФИО
  const initials = user?.fio
    ? user.fio.trim().split(" ").filter(Boolean).map(word => word[0]).slice(0, 2).join("").toUpperCase()
    : "";
    // ? userData.fio.split(" ").map(word => word[0]).join("").toUpperCase()
    // : "";

  // Текст для тултипа (минимум ФИО + email + телефон)
  const tooltipText = (
    <div>
      <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}> {user?.fio || "Неизвестный пользователь"} </Typography>
      <Typography variant="body2">Email: {user?.email || "—"}</Typography>
      <Typography variant="body2"> Телефон: {user?.mobile_number || "—"} </Typography>
    </div>
  );

  if (useToolTip) {
    return (
      <Tooltip title={tooltipText} arrow placement="top" sx={{marginRight}}>
        <Avatar
          src={photo}
          sx={{
            width:size,         
            height:size,           
            bgcolor: !src ? "primary.main" : undefined, // если нет фото — фон
            fontSize: "1.5rem",//надо поправить будет
          }}
        >
          {!src && initials}
        </Avatar>
      </Tooltip>
    );
  }
  else {
    return (
      <Avatar
        src={photo}
        sx={{
          width:size,         
          height:size,        
          marginRight,   
          bgcolor: !src ? "primary.main" : undefined, // если нет фото — фон
          fontSize: "1.5rem",//надо поправить будет
        }}
      >
        {!src && initials}
      </Avatar>
    )
  }
}
